"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var CmsPostsRecordsListCtl = /** @class */ (function (_super) {
    __extends(CmsPostsRecordsListCtl, _super);
    function CmsPostsRecordsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_preview_text = UIUtils_1.UIUtils.IProp2Str(function (o) { o.preview_text; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_cms_image_url = UIUtils_1.UIUtils.IProp2Str(function (o) { o.cms_image_url; });
        _this.dk_post_category_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.post_category_id; });
        _this.dk_post_category_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.post_category_title; });
        _this.dk_app_language_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_id; });
        _this.dk_app_language_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_title; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this.dk_post_date2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.post_date2; });
        _this._errDialog = errDialog;
        return _this;
    }
    CmsPostsRecordsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0,
            cdn_baseurl: ""
        };
    };
    CmsPostsRecordsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "object with id [" + id + "] not found !";
    };
    CmsPostsRecordsListCtl.prototype.LoadData = function (postCategoryId, onDone) {
        var _this = this;
        webAApi_1.ListPostRecordsByPostDataIdGet.exec({ post_category_id: postCategoryId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            _this.DATA.cdn_baseurl = resp.cdn_baseurl;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    post_category_id: resp.list[i].post_category_id,
                    post_category_title: resp.list[i].post_category_title,
                    title: resp.list[i].title,
                    app_language_id: resp.list[i].app_language_id,
                    app_language_title: resp.list[i].app_language_title,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    preview_text: resp.list[i].preview_text,
                    cms_image_url: resp.list[i].cms_image_url,
                    post_date2: moment(resp.list[i].post_date_uts_ms).utc(false),
                    is_locked: resp.list[i].is_locked,
                    post_year: resp.list[i].post_year,
                    post_month: resp.list[i].post_month,
                    post_day: resp.list[i].post_day,
                    post_hour: resp.list[i].post_hour,
                    post_minute: resp.list[i].post_minute,
                    post_second: resp.list[i].post_second
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CmsPostsRecordsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddPostRecord.exec({
            data: {
                post_category_id: data.post_category_id,
                title: data.title,
                preview_text: data.preview_text,
                app_language_id: data.app_language_id,
                cms_image_url: data.cms_image_url,
                publish_year: data.publish_year,
                publish_month: data.publish_month,
                publish_day: data.publish_day,
                publish_hour: data.publish_hour,
                publish_minute: data.publish_minute,
                publish_second: data.publish_second,
                is_locked: data.is_locked,
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                post_category_id: data.post_category_id,
                post_category_title: resp.post_category_title,
                title: data.title,
                app_language_id: data.app_language_id,
                app_language_title: resp.app_language_title,
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_changed2: moment(resp.date_added_uts_ms).utc(false),
                preview_text: data.preview_text,
                cms_image_url: data.cms_image_url,
                post_date2: moment(resp.publish_date_uts_ms).utc(false),
                is_locked: data.is_locked,
                post_year: data.publish_year,
                post_month: data.publish_month,
                post_day: data.publish_day,
                post_hour: data.publish_hour,
                post_minute: data.publish_minute,
                post_second: data.publish_second
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CmsPostsRecordsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditPostRecord.exec({
                data: {
                    post_record_id: data.key,
                    title: data.title,
                    publish_year: data.publish_year,
                    publish_month: data.publish_month,
                    publish_day: data.publish_day,
                    publish_hour: data.publish_hour,
                    publish_minute: data.publish_minute,
                    publish_second: data.publish_second,
                    is_locked: data.is_locked,
                    app_language_id: data.app_language_id,
                    preview_text: data.preview_text,
                    cms_image_url: data.cms_image_url
                }
            }, function (resp) {
                _tmp.title = data.title;
                _tmp.app_language_id = data.app_language_id;
                _tmp.app_language_title = resp.app_language_title;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.post_date2 = moment(resp.publish_date_uts_ms).utc(false);
                _tmp.post_year = data.publish_year;
                _tmp.post_month = data.publish_month;
                _tmp.post_day = data.publish_day;
                _tmp.post_hour = data.publish_hour;
                _tmp.post_minute = data.publish_minute;
                _tmp.post_second = data.publish_second;
                _tmp.cms_image_url = data.cms_image_url;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CmsPostsRecordsListCtl.prototype.SetDataContent = function (postRecordId, contentBase64, onDone) {
        var _this = this;
        var _tmp = this.getById(postRecordId);
        if (_tmp) {
            webAApi_1.DoEditPostRecordContent.exec({
                data: {
                    post_record_id: postRecordId,
                    content_base64: contentBase64
                }
            }, function (resp) {
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CmsPostsRecordsListCtl.prototype.GetDataContent = function (postRecordId, onDone) {
        var _this = this;
        var _tmp = this.getById(postRecordId);
        if (_tmp) {
            webAApi_1.DetailsPostRecordContentGet.exec({
                post_record_id: postRecordId
            }, function (resp) {
                if (onDone) {
                    onDone(resp.content);
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CmsPostsRecordsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    CmsPostsRecordsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeletePostRecord.exec({ data: { post_record_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return CmsPostsRecordsListCtl;
}(BaseController_1.BaseController));
exports.CmsPostsRecordsListCtl = CmsPostsRecordsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_posts/ctl/CmsPostsRecordsListCtl.ts
// module id = 943
// module chunks = 0